import { POSTFORM, POST, GET } from '@/utils/request'
import Api from './url'

export const helpBuyAccount = async (params: object) => {
  return await GET({ url: Api.helpBuyAccount, params, showError: false })
}
export const accountRecord = async (params: object) => {
  return await GET({ url: Api.accountRecord, params, showError: false })
}
